import { ExtensionMessage } from "./models/extensionMessage.js";
import { ExtensionMessageType } from "./models/extensionMessageType.js";
export class ExtensionClient {
  constructor() {
    window.addEventListener('message', event => this.onHandshakeReceived(event, this), {
      once: true
    }); // Once option sets this handler only once for the handshake 
  }
  executionComplete(encryptedPayload) {
    if (!this.messagePort) {
      throw new Error('Handshake has not been completed!');
    }
    const request = new ExtensionMessage(ExtensionMessageType.ExecutionComplete, encryptedPayload);
    this.messagePort.postMessage(request);
  }
  onHandshakeReceived(event, client) {
    switch (event.data.type) {
      case ExtensionMessageType.Handshake:
        client.Handshake(event);
        break;
      default:
        throw new Error(`Message type '${event.data.type}' not allowed!`);
    }
    ;
  }
  Handshake(event) {
    this.messagePort = event.ports[0];
    this.messagePort.onmessage = this.onMessageReceived;
    this.encryptedExtensionContext = event.data.encryptedPayload;
    const onContextReceivedEvent = new CustomEvent(ExtensionClient.onContextReceived, {
      detail: this.encryptedExtensionContext
    });
    document.dispatchEvent(onContextReceivedEvent);
  }
  onMessageReceived(event) {
    // Subsequent message coming from the Imagine App (iframe parent)
    const onMessageReceivedEvent = new CustomEvent(ExtensionClient.onMessageReceived, {
      detail: event.data.encryptedPayload
    });
    document.dispatchEvent(onMessageReceivedEvent);
  }
}
ExtensionClient.onContextReceived = "onContextReceived";
ExtensionClient.onMessageReceived = "onMessageReceived";